import type { Step } from '@/components/wizard/Step';

import { SubmitJobStep } from './steps/SubmitJobStep';
import type { SubmitJobWizardState } from './submitJobWizardState';

export const SubmitJobFlow: Step<SubmitJobWizardState> = {
  id: 'submit_job',
  Component: SubmitJobStep,
};
